import debounce from 'lodash.debounce'
export default debounce



// WEBPACK FOOTER //
// ./~/_vux@2.9.0@vux/src/tools/debounce/index.js